import React, { useCallback, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./truncated_text.scss";

export interface TruncatedTextProps {
  text: string;
  maxWidth?: number;
  children?: React.ReactNode;
}

export function TruncatedText({ text, maxWidth = 300, children }: TruncatedTextProps) {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const show = useCallback(() => {
    const el = triggerRef.current;
    if (!el) return;
    if (el.scrollWidth <= el.clientWidth) return;
    setOpen(true);
  }, []);

  const hide = useCallback(() => setOpen(false), []);

  useLayoutEffect(() => {
    if (!open || !triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setPos({
      top: rect.bottom,
      left: rect.left + rect.width / 2,
    });
    const onScroll = () => setOpen(false);
    window.addEventListener("scroll", onScroll, true);
    return () => window.removeEventListener("scroll", onScroll, true);
  }, [open]);

  return (
    <>
      <span
        ref={triggerRef}
        className="rd-truncate"
        style={{ maxWidth }}
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {children ?? text}
      </span>
      {open &&
        createPortal(
          <div
            className="rd-truncate-tooltip"
            style={{ top: pos.top, left: pos.left }}
          >
            <div className="rd-truncate-tooltip__body">{text}</div>
          </div>,
          document.body,
        )}
    </>
  );
}
